import { cn } from 'noddi-ui-common';

import { getProgressStepLabel, getStepMeta, ProgressStep } from '../utils/statusMapping';

const STEPS: ProgressStep[] = [0, 1, 2, 3];

type TireOfferProgressStripProps = {
  current: ProgressStep;
};

export const TireOfferProgressStrip = ({ current }: TireOfferProgressStripProps) => (
  <div className='flex items-start gap-2'>
    {STEPS.map((step) => {
      const reached = step <= current;
      const meta = getStepMeta(step);
      return (
        <div key={step} className='flex min-w-0 flex-1 flex-col items-stretch gap-1.5'>
          <span className={cn('h-1.5 rounded-full', reached ? meta.dot : 'bg-muted')} />
          <span
            className={cn(
              'min-w-0 text-[10px] leading-tight break-words whitespace-normal',
              step === current && current !== 3 ? 'font-semibold text-foreground' : 'text-muted-foreground'
            )}
          >
            {getProgressStepLabel(step)}
          </span>
        </div>
      );
    })}
  </div>
);
